const streetView = [];

export default streetView;
